import { fitArms, armState } from '../lib/fitSymbols';

const ST = ['none', 'open', 'closed'];
// valve cross / tee: each arm (= connected pipe direction) has no valve, an open or a closed valve
export function ArmValves({ t, obj, patch, project, onChange }) {
  const arms = fitArms(obj, project.pipes, project.fittings), dirs = String(t.armDirs || 'N,NE,E,SE,S,SW,W,NW').split(',');
  const set = (m) => { patch({ arms: { ...(obj.arms || {}), ...m } }); onChange?.(); };
  const all = (v) => set(Object.fromEntries(arms.filter((a) => armState(obj, a.key) !== 'none').map((a) => [a.key, v])));
  const nV = arms.filter((a) => armState(obj, a.key) !== 'none').length, nC = arms.filter((a) => armState(obj, a.key) === 'closed').length;
  return (
    <div className="fx-box arm-box" data-testid="arm-valves">
      <b>🔀 {t.armTitle}</b>
      <small className="muted" data-testid="arm-summary">{t.armSum.replace('{a}', arms.length).replace('{v}', nV).replace('{c}', nC)}</small>
      {arms.map((a, i) => {
        const s = armState(obj, a.key);
        return (
          <div key={a.key} className={`arm-row arm-${s}`} data-testid={`arm-row-${i}`}>
            <span className="arm-lbl"><i className="arm-dir" style={{ transform: `rotate(${a.b}deg)` }}>↑</i>{dirs[Math.round(a.b / 45) % 8]}{a.name ? ` · ${a.name}` : ''}</span>
            <span className="chip-group">{ST.map((v) => <button key={v} type="button" className={`chip seg ${s === v ? 'on' : ''}`} data-testid={`arm-${v}-${i}`} onClick={() => set({ [a.key]: v })}>{t['arm_' + v]}</button>)}</span>
          </div>
        );
      })}
      {nV > 1 && <div className="row"><button type="button" className="btn btn-outline btn-sm" data-testid="arm-all-open" onClick={() => all('open')}>🟢 {t.armAllOpen}</button><button type="button" className="btn btn-outline btn-sm" data-testid="arm-all-closed" onClick={() => all('closed')}>🔴 {t.armAllClosed}</button></div>}
    </div>
  );
}
